export default function renderDiscountLabel(qualifiers, promoList) {
  const discountLabels = []

  if (
    qualifiers &&
    qualifiers.seniorReqd &&
    shouldShowDisclaimer(promoList, ['SR', 'S2', 'SB'])
  ) {
    discountLabels.push(
      '**One guest in the stateroom must be 55 years of age or older.'
    )
  }
  if (
    qualifiers &&
    qualifiers.militaryReqd &&
    shouldShowDisclaimer(promoList, ['MI', 'OS', 'M1'])
  ) {
    discountLabels.push(
      '**One guest in the stateroom must be an active personnel currently servicing in the Canadian National Defense or United States Military, a retiree of these services, a veteran with an honorable discharge, or a spouse of an actively deployed military personnel.'
    )
  }

  if (
    qualifiers &&
    qualifiers.policeReqd &&
    shouldShowDisclaimer(promoList, ['PO', 'PL', 'FI', 'F1'])
  ) {
    discountLabels.push(
      '**One guest in the stateroom must be an active, retired or volunteer employee of a city or state/province Law Enforcement Agency, Fire Department or Emergency Medical Services in the United States or Canada.'
    )
  }
  if (
    qualifiers &&
    qualifiers.fireFighterReqd &&
    shouldShowDisclaimer(promoList, ['FI', 'F1', 'PO', 'PL'])
  ) {
    discountLabels.push(
      '**One guest in the stateroom must be an active, retired or volunteer employee of a city or state/province Law Enforcement Agency, Fire Department or Emergency Medical Services in the United States or Canada.'
    )
  }

  if (
    qualifiers &&
    qualifiers.stateCode &&
    shouldShowDisclaimer(promoList, ['RE', 'IS', 'RS', 'R2'])
  ) {
    discountLabels.push(
      '**Resident Special – One guest in the stateroom must be a resident of an eligible state to qualify for the offer.'
    )
  }

  if (
    qualifiers &&
    qualifiers.loyaltyId &&
    shouldShowDisclaimer(promoList, [
      'WO',
      'CE',
      'CL',
      'CT',
      'LB',
      'LG',
      'LO',
      'OC',
      'ON',
      'C1',
      'CB',
      'CD',
      'EV',
      'LX',
      'OL'
    ])
  ) {
    discountLabels.push(
      '**Loyalty Rate – One guest in the stateroom must be an eligible member of our loyalty program. "'
    )
  }
  return discountLabels
}

const shouldShowDisclaimer = (promoList, disclaimersToCheck) => {
  return (
    promoList &&
    promoList.some(promo => {
      return disclaimersToCheck.some(code => code === promo.code)
    })
  )
}
